import React, {useContext} from 'react';
import LogosContext from "app/react/components/logos/LogosContext";
import Logo from "app/react/components/logos/Logo";

export default function Logos() {

  const { logos }  = useContext(LogosContext)

  return (
    <>
      {logos.length > 0 && (
        <div className="dm-logos__logos">
          {logos.map((logo, i) => <Logo key={i} {...logo} />)}
        </div>
      )}
    </>
  )
}